import api from "./api";

export const getDetailBookingCancelled = async (id) => {
  return api
    .get({
      endpoint: `/booking/own/canceled/${id}`,
      port: process.env.REACT_APP_PORT_BOOK,
    })
    .then((res) => res.data)
    .catch((err) => err.response.data);
};
